import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

import { TabPanel } from '@grapecity/wijmo.nav';
import { FlexGrid, CellRangeEventArgs } from '@grapecity/wijmo.grid';

/**
 * EC使用画像指示画面を管理するクラス
 *
 * @export KYMW5002SearchResultComponent
 * @class KYMW5002SearchResultComponent
 */
@Component({
  selector: 'app-kymw5002-search-result',
  templateUrl: 'kymw5002-search-result.component.html',
  styleUrls: ['kymw5002-search-result.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5002SearchResultComponent implements OnInit {

  @ViewChild('dgv_PcodeInfoList', { static: true }) dgv_PcodeInfoList: FlexGrid;
  @ViewChild('hli_GoodsImageList', { static: true }) hli_GoodsImageList: ElementRef;
  @ViewChild('hli_UseHistoryImageList', { static: true }) hli_UseHistoryImageList: ElementRef;
  @ViewChild('hli_SearchImageList', { static: true }) hli_SearchImageList: ElementRef;
  @ViewChild('tab_SearchResult', { static: true }) tab_SearchResult: TabPanel;
  @ViewChild('goodsImageGroups', { static: true }) goodsImageGroups: ElementRef;
  @ViewChild('useHistoryImageGroups', { static: true }) useHistoryImageGroups: ElementRef;
  @ViewChild('searchImageGroups', { static: true }) searchImageGroups: ElementRef;

  @Input() goodsImageList: Array<any> = null;
  @Input() pcodeList: Array<any> = null;
  @Input() pcodeInfoList: Array<any> = null;
  @Input() useHistoryImageList: Array<any> = null;
  @Input() searchImageList: Array<any> = null;

  @Output() eventBtnSearch_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventPcodeList_CHANGE: EventEmitter<any> = new EventEmitter;
  @Output() eventPcodeInfoList_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventGoodsImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventUseHistoryImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventSearchImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;

  public pCode = String('');
  public goodsImageCnt = Number(0);
  public useHitoryImageCnt = Number(0);
  public searchImageCnt = Number(0);



  /**
   *Creates an instance of KYMW5002SearchResultComponent.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @memberof KYMW5002SearchResultComponent
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
  ) { }

  /**
   * 初期処理
   *
   * @memberof KYMW1407SearchResultComponent
   */
  public ngOnInit(): void {
    // グリッドデータ変更時イベント
    this.dgv_PcodeInfoList.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.dgv_PcodeInfoList.select(-1, -1);
    });
    // グリッド選択時イベント
    this.dgv_PcodeInfoList.selectionChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.eventPcodeInfoList_CLICK.emit(e);
    });
  }
}
